'use strict';

angular.module('substoreApp.directives')

/**
 * Directive which implements a Telekom styled checkbox with some additional features
 *
 * TODO hs
 */

angular
    .module('substoreApp.directives')
    .directive('capCheckbox', CapCheckbox);

function CapCheckbox($rootScope) {
    return {
        restrict: 'EA',
        scope: {
            ngModel:     '=ngModel',
            ngRequired:  '=ngRequired',
            label:       '=capCheckboxLabel',
            hint:        '=capCheckboxHint',
            hintVisible: '=capCheckboxHintVisible',
            colSpans:    '=capCheckboxColSpans'
        },
        require: 'ngModel',
        link: function link(scope, element, attrs, ngModel) {
            scope.ctrl = scope; // looking forward to ng1.5 components
            scope.ctrl.isRequired = attrs.hasOwnProperty('ngRequired') ? scope.ngRequired : attrs.hasOwnProperty('required');

            var checkboxElement = element.find("div[role='checkbox']");

            // propagate aria stuff down to checkbox
            angular.forEach(["aria-label", "aria-labelledby"], function (property) {
                var normalizedProperty = attrs.$normalize(property);
                if (attrs.hasOwnProperty(normalizedProperty))
                    checkboxElement.attr(property, attrs[normalizedProperty]);
            });

            checkboxElement.bind('keyup', function (event) {
                if (event.keyCode == 13 || event.keyCode == 32) {
                    // transclusion might have injected more potential targets, so we
                    // have to check if event is dedicated to our checkbox itself
                    var targetInput = $(event.target).find('input')[0];
                    if (targetInput && targetInput) {
                        var newValue = !ngModel.$modelValue;
                        ngModel.$setViewValue(newValue);

                        element.find('input').prop('checked', newValue);

                        // with ng1.2 the model change on key event is not propagated
                        // to parent components, so we are urged to call a global digest
                        $rootScope.$digest();
                    }
                }
            });

        },
        templateUrl: 'templates/capCheckbox.html',
        transclude: true
    }
}